module.exports = __webpack_public_path__ + "static/ecanta-basari-hikayesi-74594cb3e2d42a9b007a0180e4cada37.png";